import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Cashin } from '../models/cash.model';
import { ServerResponse } from '../models/types';

@Injectable()
export class CashService {
  url = '';

  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this.url = baseUrl;
  }

  async SetCashIn(value: Cashin) {
    return this.http.post(this.url + 'api/CashBox/setCashIn', value)
      .toPromise()
      .then((result: ServerResponse) => {
        if (result[0].code === 1) {
          return result[0].data;
        } else {
          throw new Error(result[0].message);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/cash.service.ts